var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"buynow-logo"},[_c('img',{style:(_vm.logoStyle),attrs:{"src":require("@/assets/logo/buynow-basic.svg"),"alt":"BUYNOW logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }